import { LoadingOutlined } from '@ant-design/icons';
import { Space, Spin } from 'antd';
import React, { useEffect } from 'react';

/**
 * 统一Loading组件
 * 与初始HTML loading协调工作，避免重复显示
 *
 */

interface LoadingProps {
  /** 加载提示文字 */
  tip?: string;
  /** 是否显示在页面中央 */
  centered?: boolean;
  /** 自定义样式 */
  style?: React.CSSProperties;
}

const Loading: React.FC<LoadingProps> = ({
  tip = '加载中...',
  centered = false,
  style,
}) => {
  // 组件首次渲染时隐藏初始HTML loading
  useEffect(() => {
    if (window?.hideInitialLoading) {
      window.hideInitialLoading();
    }
  }, []);

  // 自定义加载图标，与HTML loading保持一致
  const antIcon = (
    <LoadingOutlined style={{ fontSize: 24, color: '#1890ff' }} spin />
  );

  // 居中样式（与HTML loading保持一致）
  const centeredStyle: React.CSSProperties = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    flexDirection: 'column',
    minHeight: '362px', // 与HTML loading一致
  };

  // 默认样式
  const defaultStyle: React.CSSProperties = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '24px 40px',
    height: '60vh',
    minHeight: '200px',
  };

  const finalStyle = {
    ...(centered ? centeredStyle : defaultStyle),
    ...style,
  };

  return (
    <div style={finalStyle}>
      <Space direction="vertical" align="center" size="large">
        <Spin indicator={antIcon} size="large" />
        <div
          style={{
            fontSize: '1.1rem',
            color: '#333',
            marginTop: '16px',
            textAlign: 'center',
          }}
        >
          {tip}
        </div>
      </Space>
    </div>
  );
};

export default Loading;
